<div class="content">
  <div>
    <div class="header">
      <div class="searchbar">
        <div class="heading">Filter:</div>
        <button
          mat-button
          [class.activeNone]="(filter | async) === 'ICON_FILTER_UNASSIGNED'"
          title="Unassigned Icons"
          (click)="filterForUnassigned()"
        >
          <span>Unassigned</span>
        </button>
        <button
          mat-button
          [class.activeActor]="(filter | async) === 'ICON_FILTER_ACTOR'"
          title="Icons used as actors"
          (click)="filterForActors()"
        >
          <span>Actors</span>
        </button>
        <button
          mat-button
          [class.activeWorkObject]="
            (filter | async) === 'ICON_FILTER_WORKOBJECT'
          "
          title="Icons used as work objects"
          (click)="filterForWorkobjects()"
        >
          <span>Work Objects</span>
        </button>
        <mat-form-field
          class="searchForm dense-8"
          color="accent"
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Search icons</mat-label>
          <input matInput type="text" (input)="filterByNameAndType($event)" />
        </mat-form-field>
      </div>
      <div class="buttons">
        <button
          mat-stroked-button
          class="mr-1"
          title="Import icon set"
          (click)="startIconSetImport()"
        >
          <span>Import icon set</span>
          <input
            type="file"
            accept=".domain, .iconset"
            style="display: none"
            id="importDomain"
            name="file"
            onclick="this.value=null"
            (change)="importIconSet()"
          />
        </button>
        <button
          mat-stroked-button
          class="mr-1"
          title="Upload icon"
          (click)="startIconUpload()"
        >
          <span>Upload icon</span>
          <input
            type="file"
            multiple
            accept=".svg, image/png, image/jpeg, image/gif"
            style="display: none"
            id="importIcon"
            name="file"
            onclick="this.value=null"
            (change)="importIcon()"
          />
        </button>
        <button
          mat-stroked-button
          class="mr-1"
          title="Reset to default icon set"
          (click)="loadMinimalIconConfigurationWithDefaultIcons()"
        >
          <span>Reset to default</span>
        </button>
        <button
          mat-stroked-button
          class="mr-1"
          title="Cancel changes"
          (click)="loadInitialConfiguration()"
        >
          <span>Cancel changes</span>
        </button>
        <button
          mat-flat-button
          class="mr-1"
          title="Save changes"
          color="primary"
          (click)="saveIconSet()"
        >
          <span>Save changes</span>
        </button>
      </div>
    </div>
    <div class="iconList smallScrollbar">
      @for (iconName of allFilteredIconNames | async; track iconName) {
        <app-icon-list-item [iconName]="iconName"></app-icon-list-item>
      }
    </div>
  </div>
  <app-icon-set-details></app-icon-set-details>
</div>
